import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";

// Main Menu Flags

export const PortfoliosMenuFlag = () => {
  return useFeatureFlag("Portfolio_Menu");
};

export const MaintenanceMenuFlag = () => {
  return useFeatureFlag("Maintenance_Menu");
};

export const ReportsMenuFlag = () => {
  return useFeatureFlag("Reports_Menu");
};

export const DocumentsMenuFlag = () => {
  return useFeatureFlag("Documents_Menu");
};

export const ImportMenuFlag = () => {
  return useFeatureFlag("Import_Menu");
};

export const DirectoriesMenuFlag = () => {
  return useFeatureFlag("Directories_Menu");
};

export const NotificationsMenuFlag = () => {
  return useFeatureFlag("Notifications_Menu");
};

export const AccountingMenuFlag = () => {
  return useFeatureFlag("Accounting_Menu");
};

export const ListingsMenuFlag = () => {
  return useFeatureFlag("Prospects_Menu");
};

export const TasksMenuFlag = () => {
  return useFeatureFlag("Tasks");
};
